
























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import AddQuestRoutin from './AddQuestRoutin.vue';

@Component({
    methods: {
        ...mapActions('bh-roles', { findRole: 'find' })
    },
    components: {
        AddQuestRoutin
    }
})
export default class QuestListsTable extends Vue {
    @Prop({ default: null })
    type!: string;

    @Prop({ default: null })
    routin!: string;

    pageLoading = true;
    roleId: number | null = null;
    findRole: any;

    headers = [
        {
            text: 'Display',
            align: 'start',
            sortable: false,
            value: 'display_name',
        },
        {
            text: '',
            align: 'end',
            sortable: false,
            value: 'actions',
        }
    ];

    frequencyQuestLists = [];

    public async mounted() {
        if(this.type) {
            await this.findRole({
                query: {
                    name: this.type
                }
            }).then((item: any) => {
                if(item.total === 1) {
                    this.roleId = item.data[0].id;
                    console.log(this.roleId);
                }
            });
        }
        this.pageLoading = false;
    }

}
